import ColumnModel from "@mapmycustomers/shared/types/viewModel/internalModel/ColumnModel";
import { FilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import PlatformFilterModel from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import dealFieldModel from "@app/util/fieldModel/DealFieldModel";
import { extractSimpleConditionForField } from "@app/util/filters/utils";
import { isSimpleCondition } from "@app/util/viewModel/assert";
import { convertToPlatformFilterModel } from "@app/util/viewModel/convertToPlatformFilterModel";

// The $filters the deals list fetches with: the quick search becomes a name/company/person $or.
const buildDealListFilters = (filter: FilterModel, columns: ColumnModel): PlatformFilterModel => {
  const [quickFilter, otherFilters] = extractSimpleConditionForField(filter, "quickFilter");
  const $filters: PlatformFilterModel = {
    includeAccessStatus: true,
    ...convertToPlatformFilterModel(otherFilters, columns, dealFieldModel),
  };
  if (quickFilter && isSimpleCondition(quickFilter)) {
    const { value } = quickFilter;
    $filters.$and = [
      ...($filters.$and ?? []),
      {
        $or: [
          { name: { $in: value } },
          { "account.name": { $in: value } },
          { "contact.name": { $in: value } },
        ],
      },
    ];
  }
  return $filters;
};

export default buildDealListFilters;
